import { WithoutSpecialValidation } from "./withoutSpecialValidation";

export class NeighborhoodValidation extends WithoutSpecialValidation {
  msgError = "Informe um bairro válido.";
}
